// dashboard strings (en).
const dashboard = {
	dashboard: {
		title: 'Dashboard',
		cards: 'Cards',
		searchCardPlaceholder: 'Enter card title',
		viewMore: 'View more',
		createNewCard: 'Create new card',
		createNewCardDesc: 'CardClan encourages you to connect with your loved ones and share love with them.',
		letsCreate: "Let's create",
		selectTemplate: 'Select Template',
		searchCategoryPlaceholder: 'Enter category name',
		seeLess: 'See less',
		moreCount: '+%{count} more',
		notEnoughData: 'Not enough data to show.',
		emailsOpenRate: 'Emails open rate',
		cardsOpenRate: 'Cards open rate',
		tour: {
			dashboardTitle: 'Dashboard',
			dashboardDesc: 'Welcome to your dashboard! Here you can see an overview of your activities.',
			createCardTitle: 'Create Card',
			createCardDesc: 'Click here to create a new card from a template.',
			searchCardsTitle: 'Search Cards',
			searchCardsDesc: 'You can search for your existing cards here.',
		},
		stats: {
			cardsStatistics: 'Cards Statistics',
			graph: 'Graph',
			contactsEngagement: 'Contacts engagement',
			contactEngagement: 'Contact engagement',
			emailsOpened: 'Emails Opened',
			cardsOpened: 'Cards Opened',
			conversionRate: 'Conversion Rate',
			totalReactions: 'Total Reactions',
			totalComments: 'Total Comments',
			totalDownloads: 'Total Downloads',
			last7Days: 'Last 7 Days',
			last15Days: 'Last 15 Days',
			last30Days: 'Last 30 Days',
			last2Months: 'Last 2 months',
			last6Months: 'Last 6 months',
			lastYear: 'Last year',
			allCards: 'All cards',
		},
		swal: {
			cardAlreadyDeliveredTitle: 'Card already deliverd',
			cardAlreadyDeliveredText: 'You can clone this card to schedule a new one',
			workflowCardTitle: 'This card is used in a workflow',
			workflowCardText: 'Editing merge tags or content may break your existing workflows. Are you sure you want to continue?',
			cancel: 'Cancel',
			editAnyway: 'Edit Anyway',
			openCardError: 'Encountered a problem while opening this card. Please contact support',
			cardClonedTitle: 'Card cloned successfully',
			cardClonedText: 'The card has been cloned to the selected workspace.',
			deleteConfirmTitle: 'Are you sure?',
			deleteConfirmText: 'Do you want to delete this card.',
			no: 'No',
			yes: 'Yes',
			error: 'Error',
			warning: 'Warning',
			noCategoriesFound: 'No design categories found!',
			oopsExclaim: 'Oops!',
			oops: 'Oops',
			noWorkspaces: "Looks like you don't have any workspaces yet.",
		},
	},
};
export default dashboard;
